'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { PopoverAnchor } from './popover-anchor.js';
import { PopoverClose } from './popover-close.js';
import { PopoverContent } from './popover-content.js';
import { PopoverPortal } from './popover-portal.js';
import { PopoverTrigger } from './popover-trigger.js';
export const Popover = ({ children, className, ...otherProps }) => (_jsx(PopoverPrimitive.Root, { ...otherProps, children: children }));
Popover.Content = PopoverContent;
Popover.Trigger = PopoverTrigger;
Popover.Anchor = PopoverAnchor;
Popover.Close = PopoverClose;
Popover.Portal = PopoverPortal;
